module.exports = __webpack_public_path__ + "img/freezing_rain.f57ff72c.svg";